/// CSS
import '../sass/guest.scss';
import '../css/components/password-generator.css';
import '../css/components/phone-input.css';

/// Vendor
import './vendor';

/// Custom
import './guest/custom';

/// Components
import './components/PasswordGenerator.js';
import './components/PhoneInput.js';

/// Vue Components
//import ExampleComponent from './guest/components/ExampleComponent.vue';

const app = vueApp({});
//app.component('example-component', ExampleComponent);
if (document.getElementById('app')) {
  app.mount('#app');
}
